import { render, staticRenderFns } from "./peopleData.vue?vue&type=template&id=5c54c196&scoped=true&"
import script from "./peopleData.vue?vue&type=script&lang=js&"
export * from "./peopleData.vue?vue&type=script&lang=js&"
import style0 from "./peopleData.vue?vue&type=style&index=0&id=5c54c196&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c54c196",
  null
  
)

export default component.exports